import React, { useEffect, useState } from 'react';
import style from './Edit.module.css';
import defaultImg from '../../../Assets/defaultImg.png';
import {
  changeProfilePhoto,
  editProfile,
  locationByQuery,
} from '../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import edit from 'Assets/edit.png';
import { Spinner } from '@chakra-ui/react';

const Edit = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const [inputValue, setInputValues] = useState({
    firstname: '',
    lastname: '',
    jobTitle: '',
    location: '',
    bio: '',
    email: '',
    phone: '',
    walletId: '',
    linkedinURL: '',
    customURL: '',
    preferredworkSpace: [],
    image: '',
  });
  const student = useSelector((state) => state.student);
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (student?.name) {
      setInputValues((state) => ({
        ...student,
        firstname: student?.name.split(' ')[0],
        lastname: student?.name.split(' ').pop(),
        jobTitle: student?.jobTitle || '',
      }));
      if (student?.location) {
        document.getElementById('location').value = student?.location;
      }
      if (student?.preferredworkSpace.length > 0) {
        const removeDuplicate = [...new Set(student.preferredworkSpace)];
        document.getElementById('toggle').checked = true;
        setToggle(true);
        setTimeout(() => {
          if (
            document.getElementById(removeDuplicate[0]) &&
            document.getElementById('toggle').checked
          ) {
            removeDuplicate.forEach((item) => {
              document.getElementById(item).checked = true;
            });
          }
        }, 200);
      }
    }
  }, [student]);

  useEffect(() => {
    if (toggle) {
      if (student?.preferredworkSpace) {
        const removeDuplicate = [...new Set(student.preferredworkSpace)];
        setTimeout(() => {
          if (document.getElementById(removeDuplicate[0])) {
            removeDuplicate.forEach((item) => {
              document.getElementById(item).checked = true;
            });
          }
        }, 200);
      }
    }
  }, [toggle]);

  const [formErrors, setFormErrors] = useState({});

  const [locationText, setLoadingText] = useState('');
  const [location, setLocation] = useState([]);
  const [isSubmit, setIssubmit] = useState(false);
  const [text, setText] = useState('');

  const handleChange = (e) => {
    const inputText = e.target.value;
    if (inputText.length <= maxLength) {
      setText(inputText);
    }
    const { name, value, checked } = e.target;
    if (name === 'toggle') {
      setToggle(!toggle);
      return;
    }
    if (name === 'preferredWork' && checked) {
      setInputValues({
        ...inputValue,
        preferredworkSpace: [...inputValue.preferredworkSpace, value],
      });
      return;
    } else if (name === 'preferredWork' && !checked) {
      const filteredPreferedWork = inputValue.preferredworkSpace.filter(
        (selected) => selected !== value
      );
      setInputValues({
        ...inputValue,
        preferredworkSpace: filteredPreferedWork,
      });
      return;
    }
    if (name === 'image') {
      setInputValues({
        ...inputValue,
        image: e.target.files[0],
      });
      return;
    }

    setInputValues({
      ...inputValue,
      [name]: value,
    });
  };

  // console.log("inputValue", inputValue);

  // validations
  const validation = async (value) => {
    if (!value) {
      return;
    }
    const errors = {};
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!value.firstname) {
      errors.firstname = 'First name is required!';
    }
    if (!value.lastname) {
      errors.lastname = 'Last name is required!';
    }
    if (!value.email) {
      errors.email = 'Email is required!';
    } else if (!reg.test(value.email)) {
      errors.email = 'Not valid email!';
    } else if (value.phone.length <= 9) {
      errors.phone = 'Not a valid phone number!!';
    } else if (value.phone.length > 10) {
      errors.phone = 'Phone number not more then 10 digit!';
    }

    if (!value.jobTitle) {
      errors.jobTitle = 'Job title is required!';
    }

    if (Object.keys(errors).length === 0) {
      setLoader(true);
      try {
        const { data } = await editProfile({
          ...inputValue,
          name: inputValue.firstname + ' ' + inputValue.lastname,
          preferredworkSpace:
            toggle === true ? inputValue.preferredworkSpace : [],
        });
        if (inputValue.image) {
          const formData = new FormData();
          formData.append('file', inputValue.image);
          const changeProfile = await changeProfilePhoto(formData);
        }
        Swal.fire({
          title: 'Success',
          text: 'Profile updated successfully',
          icon: 'success',
        });
        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong',
          icon: 'error',
        });
      }
    }
    return errors;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validation(inputValue).then((res) => setFormErrors(res)));
    // navigate(-1, { replace: true });
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
    }
  }, [formErrors]);

  const fetchLocation = async () => {
    const { data } = await locationByQuery(locationText);
    setLocation(data?.data);
  };
  useEffect(() => {
    if (locationText.length > 2) {
      const handler = setTimeout(() => {
        fetchLocation(locationText);
      }, 300);
      return () => clearTimeout(handler);
    }
  }, [locationText]);
  const maxLength = 500;

  // console.log('toggle', toggle)
  return (
    <div className={style.conatiner}>
      <p className={style.title}>Edit Profile</p>
      <div className={style.formContainer}>
        <div className={style.studentProfile}>
          {inputValue?.image && (
            <img src={URL.createObjectURL(inputValue.image)} alt='defaultImg' />
          )}
          {!inputValue?.image && (
            <img
              src={inputValue?.profilePhoto || defaultImg}
              alt='defaultImg'
            />
          )}
        </div>

        <label htmlFor='imgEdit' className={style.edit}>
          <img src={edit} alt='editIcon' className={style.editIcon} />
          <input
            type='file'
            id='imgEdit'
            name='image'
            onChange={handleChange} 
            hidden
          />
        </label>

        <div className={style.detailsCont}>
          <div className={style.inputWithLabel}>
            <label htmlFor='name' className={style.required}>
              First Name
            </label>
            <input
              type='text'
              placeholder='First Name'
              name='firstname'
              value={inputValue.firstname}
              onChange={handleChange}
            />
            <p style={{ color: 'red' }}>{formErrors.firstname}</p>
          </div>
          <div className={style.inputWithLabel}>
            <label htmlFor='name' className={style.required}>
              Last Name
            </label>
            <input
              type='text'
              placeholder='Last Name'
              name='lastname'
              value={inputValue.lastname}
              onChange={handleChange}
            />
            <p style={{ color: 'red' }}>{formErrors.lastname}</p>
          </div>
          <div className={style.inputWithLabel}>
            <label htmlFor='name' className={style.required}>
              Job Title
            </label>
            <input
              type='text'
              placeholder='Job title'
              name='jobTitle'
              value={inputValue.jobTitle}
              onChange={handleChange}
            />
            <p style={{ color: 'red' }}>{formErrors.jobTitle}</p>
          </div>
          <div
            className={style.inputWithLabel}
            style={{
              position: 'relative',
            }}
          >
            <label htmlFor='name'>Location</label>
            <input
              type='text'
              placeholder='Add city'
              name='location'
              id='location'
              onChange={(e) => setLoadingText(e.target.value)}
            />
            {locationText && (
              <div className={style.location}>
                {location?.map((item) => (
                  <div
                    className={style.locationItem}
                    onClick={() => {
                      setInputValues({ ...inputValue, location: item });
                      document.getElementById('location').value = item;
                      setLoadingText('');
                    }}
                  >
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div className={style.infomessage}>(images size should be 190X210px)</div> */}
      <div className={style.inputWithLabel1}>
        <label htmlFor='name'>Bio</label>
        <textarea
          type='text'
          placeholder='Write a short description about yourself '
          maxLength='500'
          name='bio'
          value={inputValue.bio}
          onChange={handleChange}
        />
      </div>
      <div className={style.charecter}>
        {text.length}/{maxLength}
      </div>
      <div className={style.inputWithLabel1}>
        <label htmlFor='name' className={style.required}>
          Email ID
        </label>
        <input
          type='text'
          placeholder='Email ID'
          name='email'
          value={inputValue.email}
          onChange={handleChange}
          disabled
        />
        <p style={{ color: 'red' }}>{formErrors.email}</p>
      </div>
      <div className={style.inputWithLabel1}>
        <label htmlFor='name'>Contact Number</label>
        <input
          type='number'
          placeholder='Contact Number'
          name='phone'
          value={inputValue.phone}
          onChange={handleChange}
        />
        <p style={{ color: 'red' }}>{formErrors.phone}</p>
      </div>{' '}
      <div className={style.inputWithLabel1}>
        <label htmlFor='name'>Marketplace ID</label>
        <input
          type='text'
          placeholder='Add your Ajna Marketplace ID'
          name='walletId'
          value={inputValue.walletId}
          onChange={handleChange}
        />
      </div>{' '}
      <div className={style.inputWithLabel1}>
        <label htmlFor='name'>Linkedin URL</label>
        <input
          type='text'
          placeholder='Linkedin URL'
          name='linkedinURL'
          value={inputValue.linkedinURL}
          onChange={handleChange}
        />
      </div>{' '}
      <div className={style.inputWithLabel1}>
        <label htmlFor='name'>Custom URL</label>
        <input
          type='text'
          placeholder='Custom URL'
          name='customURL'
          value={inputValue.customURL}
          onChange={handleChange}
        />
      </div>
      <div className={style.opentowork}>
        <div className={style.openWorkTxt}>Open To Work</div>
        <label className={style.switch}>
          <input
            type='checkbox'
            onChange={handleChange}
            name='toggle'
            id='toggle'
          />
          <span className={style.slider}></span>
        </label>
      </div>
      {toggle && (
        <div className={style.preffered}>
          <div className={style.prefferedkTxt}>
            Preferred Workplace <span>(Select minimum 1 option)</span>{' '}
          </div>
          <div className={style.prefreed_checkbox}>
            <input
              type='checkbox'
              name='preferredWork'
              value='Open To Relocate'
              id='Open To Relocate'
              onChange={handleChange}
            />
            <label htmlFor='openTorelocate'>Open To Relocate</label>
          </div>
          <div className={style.prefreed_checkbox}>
            <input
              type='checkbox'
              name='preferredWork'
              value='Work From Home'
              id='Work From Home'
              onChange={handleChange}
            />
            <label htmlFor=''>Work From Home</label>
          </div>
          <div className={style.prefreed_checkbox}>
            <input
              type='checkbox'
              name='preferredWork'
              value='Work From Office'
              id='Work From Office'
              onChange={handleChange}
            />
            <label htmlFor=''>Work From Office</label>
          </div>
          <div className={style.prefreed_checkbox}>
            <input
              type='checkbox'
              name='preferredWork'
              value='Hybrid'
              id='Hybrid'
              onChange={handleChange}
            />
            <label htmlFor=''>Hybrid</label>
          </div>
        </div>
      )}
      <div className={style.btnContainer}>
        <button
          onClick={handleSubmit}
          style={{ cursor: 'pointer', background: '#6c56fb' }}
          disabled={loader ? true : false}
        >
          {loader ? <Spinner /> : 'Save'}
        </button>
        <button
          onClick={() => navigate(-1, { replace: true })}
          style={{
            cursor: 'pointer',
            color: '#000000',
            border: '1px solid #CECCD1',
          }}
        >
          Discard
        </button>
      </div>
    </div>
  );
};

export default Edit;
